export default "__VITE_ASSET__DLBzKbPR__"